import styles from "./styles.module.scss";

export const LoadingScreen = () => {
  return (
    <div className={styles.loadingScreen}>
      <div className="title-container" />
      <div className="content-row-1" />
      <div className="content-row-2" />
    </div>
  );
};
